// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PaymentTransactionModifyController = function ($scope, $routeParams, $http, PaymentTransactions) {
    $scope.paymentTransaction = PaymentTransactions.get({ transactionId: $routeParams.paymentId });
    $scope.modifyData = { UpdateLedger: false, FinishTriggerProcess: false, Status: "" };
    $scope.modifyTransaction = function () {
        $http({
            method: "POST",
            url: baseUrl + "api/v1/PaymentTransactions/" + $scope.paymentTransaction.Id + "/modify",
            data: $scope.modifyData,
        },
        function (data) {
            $window.history.back();
        },
        function (data) {
            $window.history.back();
        });
    };
};
PaymentTransactionModifyController.$inject = ['$scope', '$routeParams', '$http', 'PaymentTransactions'];
